import React from 'react';
import { Segment } from 'semantic-ui-react';
import Yells from '../yellbox';

export default () => {
  return (
    <Segment className="gm_tools-container">
      <Yells />
    </Segment>
  );
};
